import * as Reducers from './ron.reducers';

export const RonReducers = {
  Reducers,
};
